import { useState } from 'react';
import { Screen } from '../../components/lease/Screen';
import { BrandHeading } from '../../components/lease/BrandHeading';
import { PrimaryButton } from '../../components/lease/PrimaryButton';
import { analysisApi } from '../../services/analysis';

// Mockup "11a Save Report": email-the-report step reached from the Risk
// Report's new "Save Report" button. Content/flow from the mockup; styling
// per UI-BUILD-STANDARD.md.
export function SaveReport({ documentId, onSent, onReturnToReport, onDone }) {
  const [sending, setSending] = useState(false);
  const [error, setError] = useState(null);

  const handleSend = async () => {
    setSending(true);
    setError(null);
    try {
      const result = await analysisApi.emailReport(documentId);
      onSent(result.to);
    } catch (e) {
      setError(e.message);
    } finally {
      setSending(false);
    }
  };

  return (
    <Screen>
      <header className="animate-fade-in text-center">
        <BrandHeading className="text-4xl">Save your report</BrandHeading>
        <p className="mt-3 text-slate-600 dark:text-slate-300">
          LeaseCheck will send your report to your email.
        </p>
      </header>

      <div className="mt-8 animate-slide-in space-y-3">
        <PrimaryButton onClick={handleSend} disabled={sending}>
          {sending ? 'Sending…' : 'Email me the report'}
        </PrimaryButton>

        {error && (
          <p className="text-center text-sm text-rose-600 dark:text-rose-400">{error}</p>
        )}

        <button
          onClick={onReturnToReport}
          className="w-full rounded-xl bg-white py-4 text-lg font-bold text-emerald-700 ring-1 ring-emerald-200 transition hover:bg-emerald-50 dark:bg-slate-800/60 dark:text-emerald-400 dark:ring-slate-700"
        >
          Return to report
        </button>

        <button
          onClick={onDone}
          className="w-full rounded-xl bg-white py-4 text-lg font-bold text-emerald-700 ring-1 ring-emerald-200 transition hover:bg-emerald-50 dark:bg-slate-800/60 dark:text-emerald-400 dark:ring-slate-700"
        >
          Done
        </button>
      </div>
    </Screen>
  );
}

export default SaveReport;
